<template>
  <div class="wrapper">
    <page-header />
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img v-if="productDetail.cover_image" class="d-block img-raised" :src="productDetail.cover_image.path" />
          </div>
          <div class="col-md-6 ml-auto mr-auto">
            <h4 class="title">{{ productDetail.name }}</h4>
            <p class="category" style="white-space: pre-line;">商品內容：{{ productDetail.summary }}</p>

            <div class="staging">
              <div class="staging-item" v-for="plan in productDetail.plans">
                <input v-model="selectPlan" type="radio" :id="`period-${plan.period_count}`" name="period" :value="plan">
                <label :for="`period-${plan.period_count}`">{{ plan.period_count }}期</label>
              </div>
            </div>

            <div class="price">月付 <strong>NT$ {{ selectPlan.period_amount }}</strong> * {{ selectPlan.period_count }}期</div>

            <div class="price">總金額 <strong>NT$ {{ selectPlan.period_count * selectPlan.period_amount }}</strong></div>

            <button type="button" class="btn btn-info" @click.prevent="buy">立即購買</button>
          </div>
          <div class="col-md-12 ml-auto col-xl-12 mr-auto">
            <card class="tab">
              <tabs
                slot="raw-content"
                tab-content-classes="tab-content-padding text-center"
                type="info"
              >
                <tab-pane>
                  <template slot="label">商品說明</template>
                  <div class="description" v-html="productDetail.description"></div>
                </tab-pane>
                <tab-pane>
                  <template slot="label">購物須知</template>
                  <div class="notice" v-html="productDetail.notice"></div>
                </tab-pane>
              </tabs>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Card,
  Button,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane
} from "@/components";
import {PRODUCT_DETAIL_QUERY} from "@/services/graphql/product";
import PageHeader from "@/views/partials/PageHeader";
import { Carousel, CarouselItem, Select, Option, Tooltip } from "element-ui";

export default {
  name: "product-page",
  bodyClass: "product-page",
  components: {
    PageHeader,
    Card,
    Collapse,
    CollapseItem,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      selectPlan: {
        period_amount: 0,
        period_count: 0,
      },
      productDetail: {
        cover_image: {},
        plans: []
      },
    };
  },
  methods: {
    buy() {
      this.$router.push({name: 'OrderConfirm', query: {
          product_id: this.$route.params.product_id,
          period_count: this.selectPlan.period_count,
      }});
    },
    async getProductDetail() {
      try {
        const q = await this.$apollo.query({
          query: PRODUCT_DETAIL_QUERY,
          variables: {
            product_id: parseInt(this.$route.params.product_id)
          },
          fetchPolicy: "network-only"
        });

        if(!q.data.productDetail) {
          this.$router.push({name: 'Home'});
        }

        this.productDetail = q.data.productDetail;

        this.defaultPlan();
      } catch (err) {
        console.error(err);
      }
    },
    defaultPlan() {
      const plans = this.productDetail.plans;
      if(plans.length > 0) {
        this.selectPlan = plans[plans.length - 1];
      }
    }
  },
  created() {
    this.getProductDetail();
  }
};
</script>
<style lang="scss" scoped>
.test {
  margin: 0 30px 0 30px;
}

.description {
  margin: 20px 50px 20px 50px;
}

.notice {
  margin: 20px 50px 20px 50px;
  text-align: left;
}

.tab {
  margin: 40px 0 0 0;
}

@media screen and (max-width: 600px) {
  .title {
    font-size: 1.3em;
  }
  .description {
    margin: 10px 10px 10px 10px;
  }
  .category {
    font-size: 1.3em;
  }
}

.staging {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;

  .staging-item {
    width: 60px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    margin-right: 10px;
    margin-bottom: 10px;

    label {
      display: block;
      cursor: pointer;
      background-color: #E4E4E4;
      border-radius: 5px;
    }

    input[type=radio] {
      display: none;

      &:checked + label {
        color: white;
        background-color: #39c5bb;
      }
    }
  }
}
</style>
